/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_StatusInputs */

const en_lesson_status = /** @type {(inputs: Lesson_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const he_lesson_status = /** @type {(inputs: Lesson_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סטטוס`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Lesson_StatusInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_status = /** @type {((inputs?: Lesson_StatusInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_StatusInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_status(inputs)
	return he_lesson_status(inputs)
});